import { ConsoleAdapter } from './adapters/ConsoleAdapter'
import { NewRelicBrowserAdapter, type NewRelicBrowser } from './adapters/NewRelicBrowserAdapter'
import type { MetricsClient, MetricsClientTypeKey } from './types/MetricsClient'

type AdapterFactory = (implementation?: unknown) => MetricsClient

const adapterMap: Record<MetricsClientTypeKey, AdapterFactory> = {
  NewRelicBrowser: (implementation) =>
    new NewRelicBrowserAdapter(implementation as NewRelicBrowser),
  Console: () => new ConsoleAdapter(),
}

export function createMetricsClient(
  type: MetricsClientTypeKey,
  implementation?: unknown,
): MetricsClient {
  const factory = adapterMap[type] || adapterMap.Console
  return factory(implementation)
}
